import { useState } from 'react';

import { isDocuSignEnabled } from '@/feature/docusign.feature';
import { selectAssetStatus, selectOrderType } from '@repo/api-adapters/selectors/customer-assets.selectors';

import { TELEMETRY_LOGS, logTelemetry } from '@/lib/telemetry.lib';

import { SignaturesModal } from '@/components/docusign/docusign-modal.component';
import { SignaturesListItem } from '@/components/docusign/signatures-list-item/signatures-list-item.component';
import { MODAL } from '@/components/modals/asset-modal.types';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { analyticsEvents, analyticsModalIds, trackAnalyticsEvent } from '@/utils/analytics.utils';

export const DocuSignSection = () => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);

    if (
        !isDocuSignEnabled({
            assetType,
            orderType: selectOrderType(data),
            assetStatus: selectAssetStatus(data),
        })
    ) {
        return null;
    }

    return <DocuSignContent />;
};

const DocuSignContent = () => {
    const [signaturesModalOpen, setSignaturesModalOpen] = useState(false);
    const { assetId } = useAssetParams();
    return (
        <>
            <SignaturesListItem
                onOpen={() => {
                    setSignaturesModalOpen(true);

                    trackAnalyticsEvent({
                        eventName: analyticsEvents.modalOpened,
                        custom: {
                            assetId,
                            id: analyticsModalIds.docusign,
                        },
                    });
                    logTelemetry('info', TELEMETRY_LOGS.ModalOpened, {
                        modal: {
                            name: MODAL.DOCUSIGN,
                        },
                    });
                }}
            />
            <SignaturesModal
                visible={signaturesModalOpen}
                onClose={() => {
                    setSignaturesModalOpen(false);
                }}
            />
        </>
    );
};
